import { app } from './app';
import { benefit } from './benefit';
import { components } from './components';
import { leadViaRecommendation } from './leadViaRecommendation';
import { recommenderIdentification } from './recommenderIdentification';
import { threeSessionsGift } from './threeSessionsGift';
import { validations } from './validations';

const pt = {
  ...app,
  ...benefit,
  ...components,
  ...leadViaRecommendation,
  ...recommenderIdentification,
  ...threeSessionsGift,
  ...validations,
};

export default pt;
